// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ULdT","right":"styles_right__3tYA2"};